import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "../features/counterSlice";
import configReducer from "../features/configSlice";

const store = configureStore({
  reducer: {
    counter: counterReducer,
    config: configReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export { store };
